export class ConversionRulesAPIModel {
    ConversionRulesAPI: any;
    GetRulesOptions: string;
    ConversionRulesDetailsAPI: any;
  addUpdateConversionRulesAPI: any;
    CloneConversionRules: string;
   

}
